var render = function render(){var _vm=this,_c=_vm._self._c;return _c('default-layout',[_c('event-navbar',{attrs:{"title":"Speaker"}}),_c('div',{staticClass:"container-fluid"},[_c('speaker-detail',{attrs:{"speakerId":_vm.$route.params.speakerId,"eventShortName":_vm.$route.params.shortName}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }